import Axios from "axios";
import React, { Component } from "react";
import { Doughnut } from "react-chartjs-2";
import { Badge } from "react-bootstrap";
import AppConfig from "../../../../../../config/AppConfig";
class PieChartMengisi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: ["Loading ..", "Loading.."],
      datasets: [
        {
          data: [1, 1],
          backgroundColor: ["#79B4B7", "#FFB344"],
        },
      ],
    };
  }
  async componentDidMount() {
    this.setState({ display: false });
    // let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let userdata = JSON.parse(localStorage.getItem("userdata"));

    let id_sp = sessiondata.i_idunit;
    // if (id_institusi !== "") {
    //   id_sp = id_institusi;
    // }
    // if (id_institusi === null) {
    //   id_sp = sessiondata.i_idunit;
    // }
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    Axios.get(AppConfig.urlAPiGetDashboard + session)
      .then((res) => {
        let nw1 = [
          {
            data: [res.data.result.ptmengisi, res.data.result.pttidakmengisi],
            backgroundColor: ["#79B4B7", "#FFB344"],
          },
        ];
        this.setState({
          datasets: nw1,
          total_pt: res.data.result.ptdikbud,
          label: [
            "PT yang telah mengisi bagian aspek pengaturan",
            "PT yang tidak mengisi bagian aspek pengaturan",
          ],
        });
      })
      .catch((err) => {
        alert("not found");
        console.log(err);
        this.setState({
          loading: false,
          display: false,
        });
      });
  }
  render() {
    return (
      <>
        <div className="col-md-12 text-center">
          <h4 style={{ fontFamily: "Helvetica", color: "#5c5b5b" }}>
            <strong>
              Perguruan Tinggi Yang Telah Mengisi Aspek Pengaturan Kebijakan
              SPMI
            </strong>
          </h4>
          <Badge variant="light" style={{ fontSize: "12px", color: "#4d4d4d" }}>
            Jumlah Perguruan Tinggi : <strong>{this.state.total_pt}</strong>
          </Badge>
          <hr />
        </div>
        <div className="col-md-4">
          <Doughnut
            style={{ textAlign: "center" }}
            data={{
              labels: this.state.label,
              datasets: this.state.datasets,
            }}
          />
        </div>
      </>
    );
  }
}
export default PieChartMengisi;
